import BaseService from '@/ecm/common/BaseService.js';

class DocumentIndexationService {
  baseUrl = 'document-indexation';

  getNonIndexedGrid = (paginationSettings) => BaseService.post({
        url: `${this.baseUrl}/get-grid`,
        data: paginationSettings
    });

  indexation = (ids) => BaseService.post({ url: `${this.baseUrl}/index-documents`, data: ids });
}

export default new DocumentIndexationService();
